import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CancelSuccessScreen } from "@/modules/coaching/cancel-sessions/screens/CancelSuccessScreen";

const cancelSessionRouteValidator = z.object({
  rescheduleUuid: z.string(),
});

export const Route = createFileRoute(
  "/$sessionCode/cancel/$cancelUuid/success",
)({
  validateSearch: cancelSessionRouteValidator,
  loaderDeps: ({ search: { rescheduleUuid } }) => ({ rescheduleUuid }),
  component: CancelSuccessScreen,
});
